/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Forbidden
 * @export
 * @interface GetContractsPublicItemsContractIdForbidden
 */
export interface GetContractsPublicItemsContractIdForbidden {
    /**
     * Forbidden message
     * @type {string}
     * @memberof GetContractsPublicItemsContractIdForbidden
     */
    error?: string;
}

/**
 * Check if a given object implements the GetContractsPublicItemsContractIdForbidden interface.
 */
export function instanceOfGetContractsPublicItemsContractIdForbidden(value: object): value is GetContractsPublicItemsContractIdForbidden {
    return true;
}

export function GetContractsPublicItemsContractIdForbiddenFromJSON(json: any): GetContractsPublicItemsContractIdForbidden {
    return GetContractsPublicItemsContractIdForbiddenFromJSONTyped(json, false);
}

export function GetContractsPublicItemsContractIdForbiddenFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContractsPublicItemsContractIdForbidden {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetContractsPublicItemsContractIdForbiddenToJSON(json: any): GetContractsPublicItemsContractIdForbidden {
    return GetContractsPublicItemsContractIdForbiddenToJSONTyped(json, false);
}

export function GetContractsPublicItemsContractIdForbiddenToJSONTyped(value?: GetContractsPublicItemsContractIdForbidden | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

